import http from "../../http-common";
/**
 * Author : AndréK
 * 26/08/2022
*/

//Supplier
const createSupplier = (data) => {
    return http.post("/Supplier/InsertSupplier", data);
};

const getSupplier = (data) => {
    return http.post("/Supplier/FilterSupplier", data);
};

const updateSupplier = (data) => {
    return http.post("/Supplier/UpdateSupplier", data);
};

//Address
const createSupplierAddress = (data) => {
    return http.post("/Supplier/InsertSupplierAddress", data);
};

const getSupplierAddress = (data) => {
    return http.post("/Supplier/FilterSupplierAddress", data);
};

const updateSupplierAddress = (data) => {
    return http.post("/Supplier/UpdateSupplierAddress", data);
};

//Email
const createSupplierEmail = (data) => {
    return http.post("/Supplier/InsertSupplierEmail", data);
};

const getSupplierEmail = (data) => {
    return http.post("/Supplier/FilterSupplierEmail", data);
};

const updateSupplierEmail = (data) => {
    return http.post("/Supplier/UpdateSupplierEmail", data);
};

//Phone
const createSupplierPhone = (data) => {
    return http.post("/Supplier/InsertSupplierPhone", data);
};

const getSupplierPhone = (data) => {
    return http.post("/Supplier/FilterSupplierPhone", data);
};

const updateSupplierPhone = (data) => {
    return http.post("/Supplier/UpdateSupplierPhone", data);
};


export default {
    createSupplier,
    getSupplier,
    updateSupplier,
    createSupplierAddress,
    getSupplierAddress,
    updateSupplierAddress,
    createSupplierEmail,
    getSupplierEmail,
    updateSupplierEmail,
    createSupplierPhone,
    getSupplierPhone,
    updateSupplierPhone
};
